import { UserDto, UserLanguage } from './user.dto';

export class User {
    readonly id: string;
    readonly firstName: string;
    readonly lastName: string;
    readonly fullName: string;
    readonly language: UserLanguage;

    constructor(dto: UserDto) {
        this.id = dto.id;
        this.firstName = dto.firstName;
        this.lastName = dto.lastName;
        this.fullName = `${dto.firstName} ${dto.lastName}`.trim();
        this.language = dto.language;
    }
}
